export const UPDATE_VERSION = (state, param) => {
    state.setting.version = param
}